import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title'),_c(VRow,{staticClass:"ma-1"},[_c(VCol,{attrs:{"order":_vm.$vuetify.breakpoint.smAndDown ? 'last' : 'first',"cols":"12","xl":"9","lg":"9","md":"9","sm":"12","xs":"12"}},[_c('release-note-card')],1),_c(VCol,{attrs:{"cols":"12","xl":"3","lg":"3","md":"3","sm":"12","xs":"12"}},[_c('release-list-card')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }